import { NgModule } from "@angular/core";

import { BadgeComponent } from "./badge.component";

@NgModule({
  imports: [BadgeComponent],
  exports: [BadgeComponent],
})
export class BadgeModule {}
